import { Box, Flex } from "@chakra-ui/react";
import NewYearBanner from "components/NewYearBanner";
import CarList from "components/Order/CarList";
import Filters from "components/Rent/Filters";
import HomeTimeSearchBar from "components/Rent/HomeTimeSearchBar";
import ModelCheckbox from "components/Rent/ModelCheckbox";
import SummerBanner from "components/SummerBanner";
import { addDays, differenceInHours, isAfter, set } from "date-fns";
import { initDefaultDeliveryZone, initDefaultSelectedDays } from "lib/common";
import { getDatePickerSettingsByConfigs } from "lib/order";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import appStore from "store";
import api from "store/api";

const Rent = ({
  configs = [],
  deliveryZones,
  timeOptsUnion,
  latestOrderTimeUnion,
  cityUnion,
}) => {
  const router = useRouter();
  const { t } = useTranslation("common");
  const {
    loading,
    tempSelectedCity,
    tempSelectedZone,
    tempSelectedReturnCity,
    tempSelectedReturnZone,
    selectedDays,
    selectedStartClock,
    selectedEndClock,
    tempSelectedReturnZoneId,
    tempSelectedZoneId,
    tempSelectedDays,
    tempSelectedStartClock,
    tempSelectedEndClock,
    selectedZoneId,
    selectedReturnZoneId,
    modelsFilter,
  } = appStore;

  useEffect(() => {
    appStore.loading = true;
    if (
      tempSelectedCity === "" ||
      tempSelectedZone === "" ||
      tempSelectedReturnCity === "" ||
      tempSelectedReturnZone === "" ||
      tempSelectedDays.length !== 2 ||
      tempSelectedStartClock === "" ||
      tempSelectedEndClock === "" ||
      !tempSelectedReturnZoneId ||
      !tempSelectedZoneId
    ) {
      initDefaultDeliveryZone();
      initDefaultSelectedDays();

      appStore.loading = false;
    }
    appStore.loading = false;
  }, []);

  // useEffect(() => {
  //   appStore.isCarListFetching = true;
  //   Promise.all([api.getAllOwnerSetting(), api.getDeliveryZone()]).then(
  //     (resp) => {
  //       appStore.configs = resp[0].data.data.map((config) => ({
  //         ...config,
  //         owner_id: config.location_id || "udrive",
  //       }));

  //       appStore.deliveryZones = resp[1].data.data;
  //       const { latestOrderTime, timeOpts, deliveryZonesObj } =
  //         getDatePickerSettingsByConfigs(resp[0].data.data, resp[1].data.data);
  //       appStore.timeOptsUnion = timeOpts;
  //       appStore.latestOrderTimeUnion = latestOrderTime;
  //       // appStore.latestOrderTimeUnion =
  //       //   latestOrderTime >= 720 ? latestOrderTime : 720;
  //       appStore.cityUnion = deliveryZonesObj;
  //     }
  //   );
  // }, []);

  useEffect(() => {
    if (configs.length) {
      appStore.configs = configs;
      appStore.deliveryZones = deliveryZones;
      appStore.timeOptsUnion = timeOptsUnion;
      appStore.latestOrderTimeUnion = latestOrderTimeUnion;

      appStore.cityUnion = cityUnion;

      Promise.all([api.getOrders(), api.getCars()]).then((resps) => {
        if (resps[0].isOk && resps[1].isOk) {
          appStore.orders = resps[0].data.data;
          const addUserSetting = async (list) => {
            const data = await Promise.all(
              list.map(async (car) => {
                car.owner_settings = configs.find(({ car_ids }) =>
                  car_ids.includes(car.id)
                );
                return car;
              })
            );
            appStore.cars = data;
            appStore.top_models = resps[1].data.top_models;
            appStore.isCarListFetching = false;
          };
          addUserSetting(resps[1].data.data);
        }
      });
    }
  }, [configs]);

  useEffect(() => {
    if (router.isReady) {
      if (router.query.model) {
        // 如果router.query.model的值有在modelsFilter裡面，就把它設為true，其他的都設為false
        if (modelsFilter[router.query.model] !== undefined) {
          appStore.modelsFilter = {
            ModelS: false,
            ModelX: false,
            ModelY: false,
            Model3: false,
            [router.query.model]: true,
          };
        }
      }
    }
  }, [router]);

  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [headerVisible, setHeaderVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (Math.abs(st - lastScrollTop) <= 50) {
        return; // 如果滾動距離小於或等於50px，則不做任何動作
      }

      if (st > lastScrollTop) {
        setHeaderVisible(false);
      } else {
        setHeaderVisible(true);
      }
      setLastScrollTop(st <= 0 ? 0 : st);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const isAfterNewYear = isAfter(new Date(), new Date("2025/01/27 23:59:59"));
  if (
    loading ||
    !selectedZoneId ||
    !selectedReturnZoneId ||
    selectedDays.length !== 2 ||
    selectedStartClock === "" ||
    selectedEndClock === ""
  ) {
    return <></>;
  }

  return (
    <Box align="center" bg="#F0F0F0" minH="100vh">
      <Box pos="fixed" flex="1" w="100%" zIndex="998">
        <Box
          bg="white"
          border="1px solid rgba(0, 0, 0, 0)"
          pos="relative"
          zIndex="1"
        >
          <Box
            maxW={{ base: "90%", md: "960px" }}
            alignItems="center"
            justifyContent="center"
          >
            <HomeTimeSearchBar />
          </Box>
        </Box>
        <Box
          bg="white"
          pb="16px"
          transition="all .3s ease"
          transform={
            headerVisible ? "translateY(0)" : "translateY(calc(-100% + 1px))"
          }
          borderBottom="1px solid rgba(0, 0, 0, .1)"
        >
          <Flex
            maxW={{ base: "90%", md: "960px" }}
            alignItems="center"
            justifyContent={{ base: "space-between", md: "center" }}
            pos="relative"
            pb={{ base: "0px", md: "0px" }}
            overflow={{ base: "hidden", md: "visible" }}
          >
            <ModelCheckbox />
            <Filters />
          </Flex>
        </Box>
      </Box>

      {!isAfterNewYear && (
        <Box
          w="100%"
          // maxW={{ base: "100%", md: "960px" }}
          pt={{ base: "148px", md: "150px" }}
          mb={{ base: "-148px", md: "-150px" }}
          cursor="pointer"
          onClick={() => {
            router.push({ pathname: "/newYear", query: router.query });
          }}
        >
          <NewYearBanner />
        </Box>
      )}
      {/* )} */}
      {/* {!isAfterSummer && (
        <Box
          w="100%"
          maxW={{ base: "100%", md: "960px" }}
          pt={{ base: "149px", md: "171px" }}
          cursor="pointer"
          onClick={() => {
            router.push({ pathname: "/summer", query: router.query });
          }}
        >
          <SummerBanner />
        </Box>
      )} */}
      <CarList />
    </Box>
  );
};

export async function getServerSideProps(context) {
  const { locale } = context;
  const settingResp = await api.getAllOwnerSetting();
  const deliveryZoneResp = await api.getDeliveryZone();
  const configs = settingResp.data.data.map((config) => ({
    ...config,
    owner_id: config.location_id || "udrive",
  }));

  const deliveryZones = deliveryZoneResp.data.data;
  const { latestOrderTime, timeOpts, deliveryZonesObj } =
    getDatePickerSettingsByConfigs(
      settingResp.data.data,
      deliveryZoneResp.data.data,
      "rent"
    );
  const timeOptsUnion = timeOpts;
  const latestOrderTimeUnion = latestOrderTime;
  const cityUnion = deliveryZonesObj;
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      configs: configs || [],
      deliveryZones: deliveryZones || [],
      timeOptsUnion: timeOptsUnion || [],
      latestOrderTimeUnion: latestOrderTimeUnion || 0,
      cityUnion: cityUnion || {},
    },
  };
}
export default Rent;
